import { Fragment } from 'react';

import { DetailedView } from './DetailedView';
import { TableRowContent } from './TableRowContent';
import type { SchemaCreditRequestForm } from '../../../schemas/creditRequestForm.schema';
import { DISPOSITIONSKREDIT, type DISPOSITIONSKREDIT_TYPE } from '../../../types';
import { useExpandedItem } from '../../context/ExpandedItemContext';
import { TableRow } from '../shared/TableRow';

type Props = {
    credit: SchemaCreditRequestForm[DISPOSITIONSKREDIT_TYPE][number];
    index: number;
    toggleRefinance: (index: number) => void;
    toggleHide: (index: number) => void;
    remove: (index?: number | number[]) => void;
};

export const DispositionsKredit = ({ credit, index, toggleHide, toggleRefinance }: Props) => {
    const { isExpanded, toggleItem } = useExpandedItem();
    const itemId = `${DISPOSITIONSKREDIT}.${index}` as const;
    const showDetailedView = isExpanded(itemId);

    return (
        <Fragment key={credit.id}>
            <TableRow credit={credit} tableContentRow onClick={() => toggleItem(itemId)}>
                <TableRowContent
                    credit={credit}
                    index={index}
                    showDetailedView={showDetailedView}
                    toggleHide={toggleHide}
                    toggleRefinance={toggleRefinance}
                />
            </TableRow>
            {showDetailedView && (
                <TableRow credit={credit}>
                    <DetailedView credit={credit} index={index} />
                </TableRow>
            )}
        </Fragment>
    );
};
